import * as types from '../constants/ActionTypes'
const objectAssign = require('object-assign');

const initialState = {
	me: {com:""},
	success: false
};

export default function app(state = initialState, action) {
  switch (action.type) {
    case types.SET_SUCCESS:
      return Object.assign({}, state, {success:action.data});
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./project/reducers/user.js